var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/AccountTypeConstants');

var ActionTypes = Constants.ActionTypes;

module.exports = {
	loadAccountTypeList: function (accountTypes) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.LOAD_ACCOUNT_TYPE_LIST,
            accountTypes: accountTypes
        });
    },
	setAccountType: function (accountType, isRetrieve) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SELECT_ACCOUNT_TYPE,
            accountType: accountType,
            isRetrieve: isRetrieve
        });
	},
    navigateToAcquisition: function(){
        window.location =`${window.NOA.configuration.acquisitionInvestmentUrl}?adobe_mc=${encodeURIComponent(window.NOA.adobe_mc||'')}`;
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/AccountTypeActions.js